import React from 'react'
import StartEndTrip from '../../../components/comment/startendtrip/startEndTrip'
import CompletedTrip from '../../../components/comment/startendtrip/completedTrip'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const tripDetail = () => {
  return (
    <div className='container'>
        <Row>
            <Col>
                <CompletedTrip />
            </Col>
        </Row>
        <Row>
            <Col>
                <StartEndTrip />
            </Col>
        </Row>
    </div>
  )
}

export default tripDetail